import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import AddButton from '@/components/AddButton'
import CheckButton from '@/components/CheckButton'
import LoadingButton from '@/components/LoadingButton'
import useSiteContext from '@/context/SiteContext'
import Button from '@/components/Button'
import { toast } from 'react-toastify'
import { subscribeSection, unsubscribeSection } from '@/components/useFunctions'

import {
  ClubLaTercera,
  Coronavirus,
  Culto,
  Duna,
  FactChecking,
  Finde,
  Interactivo,
  Laboratorio,
  LaTercera,
  LaTerceraAM,
  LaTerceraPM,
  LaTerceraDomingo,
  MasDeco,
  Mouse,
  MtNews,
  MtOnline,
  Paula,
  PaulaCocina,
  PiensaDigital,
  Practico,
  Pulso,
  PulsoTrader,
  QuePasa,
  ReConstitucion,
  PulsoPM,
  ElDeportivo,
  LaTerceraNoche,
  Opinion,
  EducaLT,
} from 'copesa-logos'

import LocalImage from '@/components/LocalImage'
import LocalLogo from '@/components/LocalLogo'

const StA = styled.a`
  height: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`

const DynamicRenderer = ({ dynamicComponent, ...rest }) => {
  const components = {
    ClubLaTercera,
    Coronavirus,
    Culto,
    Duna,
    FactChecking,
    Finde,
    Interactivo,
    Laboratorio,
    LaTercera,
    LaTerceraAM,
    LaTerceraPM,
    LaTerceraDomingo,
    MasDeco,
    Mouse,
    MtNews,
    MtOnline,
    Paula,
    PaulaCocina,
    PiensaDigital,
    Practico,
    Pulso,
    PulsoTrader,
    QuePasa,
    ReConstitucion,
    PulsoPM,
    ElDeportivo,
    LaTerceraNoche,
    Opinion,
    EducaLT,
  }
  const OutputComponent = components[dynamicComponent]
  if (typeof OutputComponent !== 'undefined') {
    return <OutputComponent {...rest} />
  }
  return null
}

const ToastNotification = ({ children }) => <div>{children}</div>

const Card = ({
  newsletter,
  onSubscribe,
  subscribeInmediatelly = false,
  isUnsubscribing = false,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const [isSubscribed, setIsSubscribed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [enableSubscriptionButton, setEnableSubscriptionButton] = useState(true)

  const {
    name,
    slug,
    logo,
    frequency,
    description,
    img,
    subscription,
    subscriptionurl,
    hardcodedLogo,
  } = newsletter

  const {
    email,
    addSubscription,
    getSubscription,
    subscriptions,
    removeSubscription,
    canSubscribeToPC,
    canSubscribeToLT,
  } = useSiteContext()

  //first, determine if this newsletter is only by subscription and then what type of subscription is, LT or PC. The canSubscribeToLT and canSubscribeToPC are set in the context. Check subscription newsletter first

  useEffect(() => {
    const subscriptionStatus = getSubscription(newsletter.field)

    if (subscriptionStatus) {
      setIsSubscribed(true)
    }
  }, [subscriptions])

  useEffect(() => {
    if (subscription && subscription === 'suscriptor_lt') {
      if (canSubscribeToLT) {
        setEnableSubscriptionButton(true)
        console.log('Puedo suscribirme a LT', canSubscribeToLT)
      } else if (!canSubscribeToLT) {
        setEnableSubscriptionButton(false)
        console.log('no puedo suscribirme a LT', canSubscribeToLT)
      }
    }

    if (subscription && subscription === 'suscriptor_pc') {
      if (canSubscribeToPC) {
        setEnableSubscriptionButton(true)
        console.log('Puedo suscribirme a PC', canSubscribeToPC)
      } else if (!canSubscribeToPC) {
        setEnableSubscriptionButton(false)
        console.log('no puedo suscribirme a Paula Cocina', canSubscribeToPC)
      }
    }
  }, [canSubscribeToPC, canSubscribeToLT])

  useEffect(() => {
    if (isUnsubscribing) {
      console.log('trigger unsubscribe', isUnsubscribing)
    }
  }, [isUnsubscribing])

  const RegisterToast = () => {
    setIsLoading(true)
    subscribeSection(email, newsletter.field).then(res => {
      console.log(res)
      toast(
        <ToastNotification>
          <div className="grid justify-center grid-cols-4 gap-2 pb-2">
            <span className="col-span-3 mt-1 leading-none">
              Suscrito a <strong>{newsletter.name}</strong>
            </span>
            <button
              className="font-sans text-sm uppercase text-amarillo "
              onClick={() =>
                unsubscribeSection(email, newsletter.field).then(res => {
                  console.log('desuscripción res:', res)
                  setIsSubscribed(false)
                  removeSubscription(newsletter)
                  toast(
                    <ToastNotification>
                      Desuscrito de <strong>{newsletter.name}</strong>
                    </ToastNotification>,
                  )
                  setIsLoading(false)
                })
              }>
              Deshacer
            </button>
          </div>
        </ToastNotification>,
      )
      setIsSubscribed(true)
      onSubscribe(newsletter)
      addSubscription(newsletter)
      setIsLoading(false)
    })
  }

  const UnRegisterToast = () => {
    setIsLoading(true)
    unsubscribeSection(email, newsletter.field).then(res => {
      console.log(res)
      toast(
        <ToastNotification>
          <div className="grid justify-center grid-cols-4 gap-2 pb-2">
            <span className="col-span-3 mt-1 leading-none">
              Desuscrito de <strong>{newsletter.name}</strong>
            </span>
            <button
              className="font-sans text-sm uppercase text-amarillo "
              onClick={() =>
                subscribeSection(email, newsletter.field).then(res => {
                  console.log('desuscripción res:', res)
                  setIsSubscribed(false)
                  removeSubscription(newsletter)
                  toast(
                    <ToastNotification>
                      Suscrito de vuelta a <strong>{newsletter.name}</strong>
                    </ToastNotification>,
                  )
                  setIsLoading(false)
                })
              }>
              Deshacer
            </button>
          </div>
        </ToastNotification>,
      )
      setIsSubscribed(false)
      onSubscribe(newsletter)
      removeSubscription(newsletter)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    if (isUnsubscribing) {
      UnRegisterToast()
    } else if (subscribeInmediatelly) {
      RegisterToast()
    }
  }, [])

  return (
    <StA
      className={`grid sm:grid-cols-2 grid-cols-3 gap-4 sm:p-8 p-3 shadow-md rounded transition duration-300 ease-in-out transform ${
        isSubscribed
          ? 'bg-gray-100 opacity-75'
          : 'hover:shadow-2xl hover:z-10 hover:scale-105 bg-white '
      } `}
      href={
        subscription.length > 0 &&
        subscriptionurl.length > 0 &&
        !enableSubscriptionButton
          ? subscriptionurl
          : '#'
      }
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => {
        if (!isSubscribed) {
          setIsHovered(true)
        }
      }}
      onMouseLeave={() => {
        if (!isSubscribed) {
          setIsHovered(false)
        }
      }}
      onClick={e => {
        if (subscription && !enableSubscriptionButton) {
          return
        } else {
          e.preventDefault()

          if (!isSubscribed) {
            RegisterToast()
          } else {
            setIsLoading(true)
            unsubscribeSection(email, newsletter.field).then(res => {
              console.log('desuscripción res:', res)
              setIsSubscribed(false)
              removeSubscription(newsletter)
              toast(
                <ToastNotification>
                  Desuscrito de <strong>{newsletter.name}</strong>
                </ToastNotification>,
              )
              setIsLoading(false)
            })
          }
        }
      }}>
      <div className="xl:justify-self-end">
        <LocalImage filename={img} className="xl:w-64 " />
      </div>
      <div className="col-span-2 sm:col-auto">
        <h3 className="mb-4">
          {logo && <DynamicRenderer dynamicComponent={logo} height="60" />}
          {hardcodedLogo && (
            <LocalLogo filename={hardcodedLogo} className="w-full" />
          )}
        </h3>
        <h2 className="text-xl font-bold leading-tight ">{name}</h2>
        <hr />
        <h4>{frequency}</h4>
        <hr />
        <p className="mt-2 text-sm leading-snug">{description}</p>
        {subscription && !enableSubscriptionButton && (
          <div className="flex justify-end">
            <Button as="span">Regístrate</Button>
          </div>
        )}
      </div>
      {enableSubscriptionButton && (
        <>
          {isLoading ? (
            <LoadingButton />
          ) : (
            <>{isSubscribed ? <CheckButton /> : <AddButton />}</>
          )}
        </>
      )}
    </StA>
  )
}

export default Card
